import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { OiqFormInputComponent, OiqFormPasswordComponent } from '@oiq-ui-sdk/form';
import { EMAIL_APP_STORE } from '@v2/modules/email-app/email-app.store';

@Component({
  selector: 'oiq-gmail-imap-dialog',
  imports: [ReactiveFormsModule, OiqFormInputComponent, OiqFormPasswordComponent],
  templateUrl: './gmail-imap-dialog.component.html',
})
export class GmailImapDialogComponent {
  static open(dialog: Dialog) {
    return dialog.open(GmailImapDialogComponent, {
      width: '480px',
      autoFocus: false,
    });
  }

  private store = inject(EMAIL_APP_STORE);
  private destroyRef = inject(DestroyRef);
  public dialogRef = inject(DialogRef<any, GmailImapDialogComponent>);

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  isSubmitting = signal(false);
  errorMessage = signal<string | null>(null);

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (this.form.invalid || this.isSubmitting()) {
      this.form.markAllAsTouched();
      return;
    }

    const { email, password } = this.form.getRawValue();
    this.isSubmitting.set(true);
    this.errorMessage.set(null);

    this.store
      .connectWithPassword(email!, password!)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.isSubmitting.set(false);
          this.dialogRef.close({ success: true });
        },
        error: (err: any) => {
          this.isSubmitting.set(false);
          this.errorMessage.set(
            err?.error?.message || 'Failed to connect. Please check your credentials.'
          );
        },
      });
  }
}
